import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import Logo from "./Logo";

const PHONE_DISPLAY = "09 72 12 46 84";
const PHONE_HREF = "tel:+33972124684";
const EMAIL = "contact@preventionconseil.fr";

export default function Footer() {
  return (
    <footer className="bg-[var(--pc-bg-soft)] border-t pc-line">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 py-12 lg:py-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7 pt-1">
            <div className="flex items-center gap-2.5">
              <Logo size={22} />
              <span className="font-medium text-[17px] pc-text-ink tracking-[-0.015em]">Prévention Conseil</span>
            </div>
            <p className="mt-7 pc-text-muted text-[14.5px] leading-[1.75] max-w-md">
              Montage et suivi administratif des dossiers de demande d&apos;aide FIPU auprès de la CARSAT. Pas de conseil
              technique sur le terrain — uniquement le traitement du dossier. Dispositif officiel, engagement contractuel à
              chaque étape.
            </p>
          </div>

          <div className="lg:col-span-5 pt-1 lg:pt-2 lg:justify-self-end">
            <div className="text-[11px] tracking-[0.16em] uppercase pc-text-muted font-medium mb-6">Contact</div>
            <ul className="space-y-4 text-[14.5px] w-fit">
              <li>
                <a
                  href={PHONE_HREF}
                  className="flex items-center gap-2 pc-text-ink hover:pc-text-blue"
                  data-testid="footer-phone"
                >
                  <Phone className="w-3.5 h-3.5" /> <span className="font-mono-num">{PHONE_DISPLAY}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  className="flex items-center gap-2 pc-text-ink hover:pc-text-blue"
                  data-testid="footer-email"
                >
                  <Mail className="w-3.5 h-3.5" /> {EMAIL}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t pc-line">
          <nav aria-label="Liens légaux" className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[13.5px] pc-text-ink">
            <Link to="/mentions-legales" className="hover:pc-text-blue" data-testid="footer-mentions">
              Mentions légales
            </Link>
            <span className="pc-text-muted" aria-hidden>
              ·
            </span>
            <Link to="/cgv" className="hover:pc-text-blue" data-testid="footer-cgv">
              CGV
            </Link>
            <span className="pc-text-muted" aria-hidden>
              ·
            </span>
            <Link to="/politique-de-confidentialite" className="hover:pc-text-blue" data-testid="footer-privacy">
              Politique de confidentialité
            </Link>
          </nav>

          <div className="mt-5 flex flex-col items-center gap-2.5 text-[12.5px] pc-text-muted text-center">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-1.5 sm:gap-3">
              <span>© {new Date().getFullYear()} Prévention Conseil — preventionconseil.fr</span>
              <span className="hidden sm:inline" aria-hidden>
                ·
              </span>
              <span>Site officiel · Données traitées en France</span>
            </div>

            <div className="text-[8.5px] sm:text-[9px] leading-snug" style={{ color: "var(--pc-muted-2)" }}>
              L’édition de ce site relève de la société Ecoreno France. Tous droits réservés.
            </div>
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Prévention Conseil",
            url: "https://preventionconseil.fr",
            telephone: PHONE_DISPLAY,
            email: EMAIL,
            description:
              "Montage et suivi administratif des dossiers FIPU auprès de la CARSAT — jusqu'à 75 000 €, sans avancer avant versement.",
            areaServed: "FR",
          }),
        }}
      />
    </footer>
  );
}
